const BASE_URL = 'https://school-api.husmerk.com'; // Replace with your actual base URL

export default BASE_URL;